export default __webpack_public_path__ + "static/media/tutorial-last-step.6a27cab6.svg";